import { Grid } from "@mui/material"

import { LinearLoading } from 'common'

export const InfoContract = ({ useFetchInit }) => {
    const { FetchData } = useFetchInit
    const { fetchInfoLease } = FetchData
    const { dataInfoLease, setLoadingFetchInfoLease } = fetchInfoLease
    return (
        <>
            {(setLoadingFetchInfoLease) && (<LinearLoading />)}
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>IDENTIFICADOR:</strong> {dataInfoLease?.contrato_codigo || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>NOMBRE DEL CLIENTE:</strong> {dataInfoLease?.cliente || '' }
                        </span>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>FECHA DE CONTRATO:</strong> {dataInfoLease?.contrato_fecha || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>MENSUALIDADES:</strong> {dataInfoLease?.contrato_plazo_meses || '' }
                        </span>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
